<template>
  <div class="basciMessage">
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item prop="correct" :wrapper-col="{ span: 14, offset: 4 }">
        <span>批改方式：</span>
        <a-radio-group v-model="form.correct">
          <a-radio value="1">
            手动批改
          </a-radio>
          <a-radio value="2">
            自动批改
          </a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item v-if="form.correct == '2'" prop="autoScore" :wrapper-col="{ span: 14, offset: 4 }">
        <span>
          <span>自动批改得分：</span>
          <a-input v-model="form.autoScore" style="width: 80px;" />
          <span>&nbsp;分</span>
        </span>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
        <p class="correctDesc">手动批改：由坊主对坊员提交的作业逐份进行人工批改，100分满分，60分合格</p>
        <p class="correctDesc">自动批改：坊员提交的作业由系统自动批改为合格，可设置60~100分的默认分值</p>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 4, offset: 4 }">
          <a-button @click="onSubmit" type="primary">保存</a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
export default {
  data () {
    return {
      wrapperCol: { span: 14 },
      taskCoverNum: 5,
      form: {
        correct: '',
        autoScore: ''
      },
      rules: {
        correct: [
          { required: true, message: '请选择批改方式', trigger: 'change' }
        ],
        autoScore: [
          { required: true, message: '请输入自动批改分数', trigger: 'blur' },
          { validator: this.autoCorrectScore }
        ]
      }
    }
  },
  created () {
    this.getOneAttInfo();
  },
  methods: {
    autoCorrectScore(rule, value, callback){
      const scoreReg = new RegExp('^([6-9][0-9]{1}|100)$');
      if (!scoreReg.test(value)) {
        callback(new Error('请输入60-100的整数'));
      }
      callback();
    },
    getOneAttInfo(){
      let url = this.apis.coursework.getOneAttInfoById + this.appUtils.getCourseInfo().attinfoId;
      this.http.get(url)
      .then((res)=>{
        if (res.data.checkType == 'manual'){
          this.form.correct = '1';
        } else if (res.data.checkType == 'auto'){
          this.form.correct = '2';
          this.form.autoScore = res.data.autoScore;
        }
      }).catch((err)=> {
        console.log(err);
      });
    },
    onSubmit() {
      this.$emit('basciMessageSubmit',false);
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let that = this;
          this.$confirm({
            title: '提示',
            content: '确定保存信息吗?',
            onOk() {
              that.sbmBasicSetup();
            },
            onCancel() {
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    sbmBasicSetup(){
      let data = {};
      if (this.form.correct == '1'){
        data = {
          'checkType': 'manual',
          'autoScore': ''
        };
      } else if (this.form.correct == '2'){
        data = {
          'checkType': 'auto',
          'autoScore': this.form.autoScore
        };
      }
      let url = this.apis.coursework.putCoursework + this.appUtils.getCourseInfo().attinfoId;
      this.http.put(url, data)
      .then((res)=>{
        if (res.status == 0){
          this.$message.success('保存成功');
        }
      }).catch((err)=> {
        this.$message.error(err.message);
      });
    }
  }
}
</script>

<style lang="less">
.basciMessage{
  text-align: start;
  padding: 20px 50px 0px;
  .correctDesc{
    color: #999;
    margin-bottom: 0;
    height: 20px;
    line-height: 20px;
  }
}
</style>